export interface VerificationPromptInput {
  /** Whether the user's phone is already verified. */
  phoneVerified?: boolean;
  /** Courier setting: is phone verification required. */
  requireVerification?: boolean;
  /** Courier setting: SMS verification available. */
  isSmsApiEnabled?: boolean;
  /** Courier setting: WhatsApp verification enabled. */
  useWaApi?: boolean;
  /** Server-derived: is the courier's WhatsApp session currently connected. */
  isWhatsappConnected: boolean;
  /** Whether the user has already dismissed the prompt this session. */
  dismissed: boolean;
}

/**
 * Decide whether the post-login phone-verification modal should auto-open.
 *
 * Only prompts when a *usable* channel exists — SMS, or WhatsApp that is
 * actually connected. When WhatsApp is the only channel and it is disconnected,
 * we skip the prompt rather than ask for a code that can never arrive.
 */
export const shouldPromptPhoneVerification = ({
  phoneVerified,
  requireVerification,
  isSmsApiEnabled,
  useWaApi,
  isWhatsappConnected,
  dismissed,
}: VerificationPromptInput): boolean => {
  if (phoneVerified) return false;
  if (!requireVerification) return false;
  if (dismissed) return false;

  const hasUsableMethod =
    !!isSmsApiEnabled || (!!useWaApi && isWhatsappConnected);

  return hasUsableMethod;
};
